import { del, get, set } from "idb-keyval";

const KEY = "ruralops-offline-session";
const TTL_MS = 5 * 24 * 60 * 60 * 1000; // 5 days — matches spec §4 offline window

export interface OfflineSession {
	userId: string;
	email: string;
	name: string;
	sessionId: string;
	expiresAt: number;
}

export interface OfflineSessionResult {
	session: OfflineSession | null;
	/** True when a session record existed but its TTL had elapsed. */
	expired: boolean;
}

export async function getOfflineSession(): Promise<OfflineSessionResult> {
	const record = await get<OfflineSession>(KEY);
	if (!record) return { session: null, expired: false };
	if (Date.now() > record.expiresAt) {
		await del(KEY);
		return { session: null, expired: true };
	}
	return { session: record, expired: false };
}

/** Persist (or refresh the TTL of) a display-only session — no tokens stored. */
export async function setOfflineSession(
	data: Omit<OfflineSession, "expiresAt">,
): Promise<void> {
	await set(KEY, { ...data, expiresAt: Date.now() + TTL_MS });
}

export async function clearOfflineSession(): Promise<void> {
	await del(KEY);
}
